module.exports = __webpack_public_path__ + "img/deny.e13b8f51.svg";